'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'toilets-portable';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e584';
var svgPathData = 'M96 32l96 0c17.7 0 32 14.3 32 32l0 32-160 0 0-32c0-17.7 14.3-32 32-32zM32 96l0 400c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 160 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-432c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 32zm192 32l0 80-24 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l24 0 0 112-160 0 0-320 160 0zm0 112l0 64-24 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l24 0zM384 32l104 0c17.7 0 32 14.3 32 32l0 32-168 0 0-32c0-17.7 14.3-32 32-32zM352 448l0-320 168 0 0 80-24 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l24 0 0 112-168 0zM552 208l0-144c0-35.3-28.7-64-64-64L384 0c-35.3 0-64 28.7-64 64l0 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 168 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-288zm-32 32l0 64-24 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l24 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faToiletsPortable = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;